<template>
  <div :class="$style.bentoActionCard">
    <div v-if="props.textLabel && props.isShownLabel" :class="$style.bentoActionCardLabel">
      {{ props.textLabel }}
    </div>
    <div
      v-if="props.isTypeTextButton"
      :class="[
        $style.bentoActionCardWithButton,
        { [$style.bentoActionCardWithButtonHidden]: !props.isShownButton },
      ]"
    >
      <p>
        <img
          v-if="props.isShownCupAction"
          :class="$style.bentoActionCardWithButtonIcon"
          src="/images/common/cupAction.svg?url_encode"
          alt="cupAction"
        />
        {{ props.textJoin }}
      </p>
      <BitButton
        v-if="props.isShownButton"
        is-fluid-width
        no-margin
        :class="$style.bentoActionCardButton"
        @click="$emit('openSignOrRacemodal')"
      >
        {{ storeButtons.join }}
      </BitButton>
    </div>

    <div v-if="props.isTypeTextTimer" :class="$style.bentoActionCardWithTimer">
      <p>{{ props.textTimer }}</p>
      <BitTimer
        v-if="!isEndedTimer"
        :class="$style.bentoActionCardTimer"
        :is-background="false"
        :start-time="props.startTime"
        :end-time="props.endTime"
        :title-days="components.timer.daysTitle"
        :title-hours="components.timer.hoursTitle"
        :title-minutes="components.timer.minutesTitle"
        :title-seconds="components.timer.secondsTitle"
      >
        {{ expiresInTitle }}
      </BitTimer>
      <div v-else-if="props.durationDate" :class="$style.eventCardTimerEnded">
        <img
          class="timerIconEnded"
          height="20"
          width="20"
          src="/images/common/actionCardTimerTime.svg?url_encode"
          alt="actionCardTimerTime"
        />
        {{ props.durationDate }}
      </div>
    </div>

    <div v-if="props.isTypeTextWithText" :class="$style.bentoActionCardWithText">
      <p>{{ props.textTitle }}</p>
      <span :class="$style.bentoActionCardWithTextPrize">{{ props.textPrize }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { BitButton, BitTimer } from '@bit/ui-kit';
import { useStoreButtonTitles } from '~/stores/strapi/buttonTitles';
import { useStoreComponents } from '~/stores/strapi/components';

defineEmits<{
  (e: 'openSignOrRacemodal'): void;
}>();

const props = defineProps({
  isTypeTextButton: {
    type: Boolean,
    default: false,
  },
  isTypeTextTimer: {
    type: Boolean,
    default: false,
  },
  isTypeTextWithText: {
    type: Boolean,
    default: false,
  },
  isShownButton: {
    type: Boolean,
    default: true,
  },
  isShownLabel: {
    type: Boolean,
    default: false,
  },
  isShownCupAction: {
    type: Boolean,
    default: false,
  },
  textJoin: {
    type: String,
    default: '',
  },
  textTimer: {
    type: String,
    default: '',
  },
  textTitle: {
    type: String,
    default: '',
  },
  textPrize: {
    type: String,
    default: '',
  },
  textLabel: {
    type: String,
    default: '',
  },
  startTime: {
    type: Number,
    default: 0,
  },
  endTime: {
    type: Number,
    default: 0,
  },
  durationDate: {
    type: String,
    default: '',
  },
});

const storeButtons = useStoreButtonTitles();
const components = useStoreComponents();

const expiresInTitle = computed(() => components.timer.expiresInTitle);

const isEndedTimer = computed(() => {
  if (!props.endTime) {
    return false;
  }
  return Date.now() >= props.endTime;
});
</script>

<style lang="scss" module src="./bentoActionCard.scss"></style>
